import { AccountType } from '@synergy/models';
import { AnyAction } from 'redux';

import {
    CONTACT_DETAIL_CONDITION_ERROR,
    CONTACT_DETAIL_CONDITION_ERROR_RESET,
    CONTACT_DETAIL_LOCK_SUCCESS,
    CONTACT_DETAIL_UNLOCK,
} from './contact-detail-global-actions';
import { CONTACT_DETAIL_OVERVIEW_RECEIVE_DETAILS } from '../overview/store/contact-detail-overview-actions';
import { ErrorMessage } from '../../../../../common/models/enums/error-message';
import { Organization } from '../../../../../common/models/organization';

interface ErrorContext {
    accountId: number;
    accountName: string;
    accountType: AccountType;
}

export interface ContactDetailGlobalReducerState {
    isLocked: boolean;
    organizations: Organization[];
    hasContactAssignedError: boolean;
    hasContactAssignedErrorContext: ErrorContext | null;
    errorType: ErrorMessage | null;
}

const initialContactDetailGlobalReducerState: ContactDetailGlobalReducerState = {
    isLocked: false,
    organizations: [],
    hasContactAssignedError: false,
    hasContactAssignedErrorContext: null,
    errorType: null,
};

export const contactDetailGlobalReducer = (
    state: ContactDetailGlobalReducerState = initialContactDetailGlobalReducerState,
    action: AnyAction
): ContactDetailGlobalReducerState => {
    switch (action.type) {
        case CONTACT_DETAIL_OVERVIEW_RECEIVE_DETAILS: {
            return {
                ...state,
                isLocked: action['contact']?.isLocked ?? false,
                organizations: action['contact']?.organizations ?? [],
            };
        }
        case CONTACT_DETAIL_LOCK_SUCCESS: {
            return {
                ...state,
                isLocked: true,
                hasContactAssignedError: false,
            };
        }
        case CONTACT_DETAIL_UNLOCK: {
            return {
                ...state,
                isLocked: false,
                hasContactAssignedError: false,
            };
        }
        case CONTACT_DETAIL_CONDITION_ERROR: {
            return {
                ...state,
                hasContactAssignedError: true,
                hasContactAssignedErrorContext: action['context'] as ErrorContext,
                errorType: action['errorType'] as ErrorMessage,
            };
        }
        case CONTACT_DETAIL_CONDITION_ERROR_RESET: {
            return {
                ...state,
                hasContactAssignedError: false,
            };
        }
        default:
            return state;
    }
};
